import { Dialog } from "@headlessui/react";
import { rem } from "polished";
import * as React from "react";
import { ThemeKind } from "src/types";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/components/editor/utils/use-color";
import { Close } from "@/components/icons/close";
import { UI_MODAL_BREAKPOINTS } from "@/utils/constants";

const StyledDialogPanel = withViewportStyle(Dialog.Panel)`
  position: relative;
  width: 100%;
  max-width: 37.5rem;
  overflow: unset;

  &.${ThemeKind.DEFAULT}, &.${ThemeKind.CROSBY}, &.${ThemeKind.HAZEL} {

    background: ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]};
  }

  &.${ThemeKind.NOLAN} {
    background: ${({ theme }) => theme.colors[ColorLabels.VISUALS_2]};
  }

  &.${ThemeKind.CROSBY} {
    border-radius: ${rem(16)};
  }

  @media (max-width: ${rem(UI_MODAL_BREAKPOINTS.LARGE)}) {
    max-width: 100%;
    height: 100vh;

    &.${ThemeKind.CROSBY} {
      border-radius: unset;
    }
  }
`;

const CloseButton = withViewportStyle("button")`
  position: absolute;
  top: ${rem(16)};
  right: ${rem(16)};
  z-index: var(--z-index-lowest);
  background: none;
  border: none;
  border-radius: ${rem(4)};
  cursor: pointer;
  padding: ${rem(4)};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};

  &:hover {
    background: none;
    color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY_FONT]};
  }

  &.${ThemeKind.NOLAN} {
    color: ${({ theme }) => theme.colors[ColorLabels.SECONDARY_FONT]};

    &:hover {
      background: none;
      color: ${({ theme }) => theme.colors[ColorLabels.SECONDARY_FONT]};
    }
  }
`;

interface SpeakerModalProps {
  isShowing: boolean;
  onClose: () => void;
  className?: string;
  isDismissible?: boolean;
  children: React.ReactNode;
}

export function SpeakerModal({
  isShowing,
  onClose,
  className,
  isDismissible = true,
  children,
}: SpeakerModalProps) {
  return (
    <Dialog
      open={isShowing}
      onClose={
        isDismissible
          ? onClose
          : () => {
              return;
            }
      }
    >
      <div
        className="fixed inset-0 z-50 bg-[#000a26]/60 backdrop-blur-sm"
        aria-hidden="true"
      />

      <div className="fixed inset-0 z-50 flex items-center justify-center">
        <StyledDialogPanel className={className}>
          <CloseButton
            onClick={onClose}
            aria-label="Close modal"
            className={className}
          >
            <Close className="size-6" />
          </CloseButton>
          {children}
        </StyledDialogPanel>
      </div>
    </Dialog>
  );
}
